namespace TabAurous.JobWork {
    export namespace JobWorkReturnService {
        export const baseUrl = 'JobWork/JobWorkReturn';

        export declare function Create(request: Serenity.SaveRequest<JobWorkReturnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<JobWorkReturnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<JobWorkReturnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<JobWorkReturnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetLineNo(request: Serenity.ServiceRequest, onSuccess?: (response: Purchase.GetLineNoResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "JobWork/JobWorkReturn/Create",
            Update = "JobWork/JobWorkReturn/Update",
            Delete = "JobWork/JobWorkReturn/Delete",
            Retrieve = "JobWork/JobWorkReturn/Retrieve",
            List = "JobWork/JobWorkReturn/List",
            GetLineNo = "JobWork/JobWorkReturn/GetLineNo"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetLineNo'
        ].forEach(x => {
            (<any>JobWorkReturnService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
